import { deleteContactApi, getContactApi, getContactsApi } from "api/contactUs";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  deleteContactFailure,
  deleteContactSuccess,
  getContactFailure,
  getContactSuccess,
  getContactsFailure,
  getContactsSuccess,
} from "./actions";
import { DELETE_CONTACT, GET_CONTACT, GET_CONTACTS } from "./actionTypes";

function* getContactsSaga({ payload }) {
  try {
    const { data } = yield call(getContactsApi, payload);
    yield put(getContactsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getContactsFailure(error));
  }
}

// ===================================================
// ===================================================

function* getContactSaga({ payload }) {
  try {
    const { data } = yield call(getContactApi, payload);
    yield put(getContactSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getContactFailure(error));
  }
}

// ===================================================
// ===================================================

function* deleteContactSaga({ payload }) {
  try {
    yield call(deleteContactApi, payload);
    yield put(deleteContactSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteContactFailure(error));
  }
}

// ===================================================
// ===================================================

export function* watchGetContacts() {
  yield takeEvery(GET_CONTACTS, getContactsSaga);
}

export function* watchGetContact() {
  yield takeLatest(GET_CONTACT, getContactSaga);
}

export function* watchDeleteContact() {
  yield takeLatest(DELETE_CONTACT, deleteContactSaga);
}

// ===================================================
// ===================================================

function* contactsSaga() {
  yield all([fork(watchGetContacts)]);
  yield all([fork(watchGetContact)]);
  yield all([fork(watchDeleteContact)]);
}

export default contactsSaga;
